<template>
    <modal id="cttp-modal" v-if="show" @close="close()">
        <template #header>
            CommodityTrends Trading Plan 2.0 Current Positions
        </template>
        <template #body>
            <div class="w-full pt-4 pb-6">
                <div class="w-full">
                    <p class="timestamp">Last update: {{ cttpData.last_updated }}</p>
                    <table class="table table-striped border-gray-400 border mt-4 ct-table-welcome">
                        <thead>
                            <tr class="bg-blue-500 text-white">
                                <th>Name</th>
                                <th class="text-right">Qty</th>
                                <th class="text-right">Position</th>
                                <th class="text-right">Notes</th>
                                <th class="text-right">Links</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-for="(n, index) in 5">
                            <tr :class="getClassNotes(cttpData.notes[index])" :key="index" v-if="cttpData.hidden[index]">
                                <td class="text-xs">{{ cttpData.contract[index].symbolName || '-' }} {{ cttpData.contract[index].contractMonthYear || '-' }}</td>
                                <td class="text-right text-xs">{{ cttpData.quantity[index] || '-' }}</td>
                                <td class="text-right text-xs" :class="getClassPosition(cttpData.position[index])">{{ cttpData.position[index] || '-' }}</td>
                                <td class="text-right text-xs">{{ cttpData.notes[index] || '-' }}</td>
                                <td class="text-right text-xs">
                                    <span v-if="cttpData.contract[index].symbol">
                                        <a title="Chart" :href="'/interactive-charts/' + cttpData.contract[index].symbol" class="btn-table-action font-normal">C</a>
                                        <a title="Futures Prices" :href="'/quotes/futures/' + cttpData.contract[index].symbol" class="btn-table-action font-normal">F</a>
                                    </span>
                                </td>
                            </tr>
                            </template>
                        </tbody>
                    </table>
                    <div class="paragraph mt-4 mx-4 cttp-modal_summary" v-html="cttpData.summary" v-if="cttpData.summary"></div>
                    <div class="text-center mt-2">
                        <a href="/jims-desk/trade-tracker" class="btn btn-sm btn-yellow">Click here to view the CTTP 2.0 portfolio</a>
                    </div>
                </div>
            </div>
        </template>
        <template #footer>
            <div class="flex justify-center">
                <div class="btn btn-sm btn-yellow-ghost inline-flex mx-1" @click="close()">Close</div>
            </div>
        </template>
    </modal>
</template>

<script setup>
import { ref, onMounted } from 'vue';

const props = defineProps({
  initialData: {
    type: [Object, Array],
    default: () => ({}),
    required: false,
  },
});

const cttpData = ref(props.initialData || {});
const show = ref(false);

const close = () => {
  show.value = false;
  document.cookie = 'commoditytrends_once-logged-in-user' + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
};

const getClassNotes = (notes) => {
  if (notes === 'New Position' || notes === 'New Signal') {
    return 'font-semibold';
  }
  return '';
};

const getClassPosition = (position) => {
  if (position === 'SELL') {
    return 'text-green-500';
  }
  if ( position === 'BUY') {
    return 'text-red-500';
  }
  return 'text-blue-500';
};

onMounted(() => {
  setTimeout(() => {
    show.value = true;
  }, 1000);
});
</script>

<style lang="scss">
#cttp-modal {
    @apply text-left;

    .modal-container {
        width: 60rem;

        @screen xs {
            width: 100%;
        }
    }

    .cttp-modal_summary {
        li {
            @apply mb-2;
        }
    }
}
</style>
